<template lang='pug'>
  i.svg-icon.svg-icon-link
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      
      path(d='M39.557,31.007c-9.493,9.822-7.422,26.122,3.452,33.343c0.358,0.238,0.835,0.189,1.142-0.111 c2.29-2.235,4.226-4.402,5.922-7.158c0.26-0.422,0.098-0.968-0.337-1.203c-1.659-0.9-3.309-2.584-4.238-4.365l0,0.001 c-1.114-2.216-1.492-4.699-0.903-7.266c0,0,0.002,0,0.002,0c0.677-3.284,4.205-6.34,6.897-9.167 c-0.006-0.001-0.012-0.004-0.018-0.006l10.093-10.3c4.021-4.104,10.636-4.137,14.698-0.075c4.105,4.022,4.172,10.67,0.149,14.775 l-6.11,6.285c-0.282,0.291-0.375,0.716-0.242,1.099c1.407,4.082,1.752,9.834,0.81,14.184c-0.026,0.121,0.123,0.201,0.211,0.112 l13.009-13.277c8.312-8.482,8.241-22.292-0.155-30.689C75.37,8.621,61.42,8.692,52.938,17.347L39.608,30.952 C39.591,30.97,39.575,30.989,39.557,31.007L39.557,31.007z')

      path(d='M63.876,66.22L63.876,66.22c0.009-0.002,0.017-0.007,0.026-0.009c2.654-4.854,3.175-10.424,1.932-15.852 l-0.005,0.006l-0.008-0.002c-1.182-4.834-4.422-9.635-8.825-12.59c-0.377-0.255-0.984-0.224-1.339,0.062 c-2.23,1.804-4.414,4.117-5.853,7.067c-0.226,0.463-0.057,1.02,0.389,1.28c1.672,0.97,3.181,2.39,4.193,4.277v-0.001 c0.786,1.333,1.564,3.863,1.062,6.578c0,0,0,0-0.001,0c-0.471,3.602-4.107,6.906-6.998,9.883l0,0.001 c-2.201,2.252-7.796,7.956-10.037,10.245c-4.021,4.104-10.669,4.173-14.773,0.152c-4.105-4.022-4.172-10.671-0.151-14.774 l6.13-6.306c0.277-0.284,0.373-0.702,0.249-1.081c-1.361-4.176-1.734-9.8-0.875-14.143c0.024-0.121-0.125-0.198-0.211-0.111 L15.968,53.979C7.573,62.548,7.644,76.5,16.127,84.981c8.569,8.396,22.448,8.254,30.843-0.314 C49.887,81.405,62.372,69.845,63.876,66.22L63.876,66.22z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
}

</script>
